<template>
  <div class="staticBook-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>预装书</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'staticBookCreate' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="list-container" v-bar>
        <div class="staticBook-handle">
          <div
            v-for="(item, idx) in staticBook"
            :key="idx"
            class="staticBook-item"
          >
            <div class="staticBook-cover">
              <img class="staticBook-img" :src="item.cover.url" alt="" />
            </div>
            <div class="staticBook-info">
              <p class="staticBook-info-title">标题</p>
              <p>{{ item.title }}</p>
              <p class="staticBook-info-title">型号：</p>
              <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                :title="item.model.join('\\')"
                v-if="
                  !(
                    item.model.length === 0 ||
                    (item.model.length === 1 && item.model[0] === '')
                  )
                "
              >
                {{ item.model.join("\\") }}
              </p>
              <p
                v-if="
                  item.model.length === 0 ||
                    (item.model.length === 1 && item.model[0] === '')
                "
              >
                暂无
              </p>

              <p class="staticBook-info-title">语言：</p>
              <p
                style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                :title="item.lang.join('\\')"
                v-if="
                  !(
                    item.lang.length === 0 ||
                    (item.lang.length === 1 && item.lang[0] === '')
                  )
                "
              >
                {{ item.lang.join("\\") }}
              </p>
              <p
                v-if="
                  item.lang.length === 0 ||
                    (item.lang.length === 1 && item.lang[0] === '')
                "
              >
                暂无
              </p>

              <p class="staticBook-info-title">文件：</p>
              <div class="omitText">
                <a
                  :href="item.file.url"
                  :download="item.file.name"
                  :title="item.file.name"
                  >{{ item.file.name }}</a
                >
              </div>
            </div>
            <div class="staticBook-btn">
              <span class="edit-btn" @click="edit(item)">编辑</span>
              <span class="del-btn" @click="remove(item)">删除</span>
            </div>
          </div>
        </div>
      </div>
      <pagination
        :pageSize="listParams.limit"
        :total="count"
        @pageNum="getPageNum"
      />
    </el-card>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import pagination from "@/components/pagination";
import DelPopup from "@/components/delPopup";
export default {
  components: {
    pagination,
    DelPopup
  },
  computed: {
    ...mapGetters(["delPopup"])
  },
  data() {
    return {
      staticBook: [],
      staticBookItem: null,
      count: 0,
      listParams: {
        page: 1,
        limit: 20
      }
    };
  },
  methods: {
    getStaticBook() {
      this.$http.getStaticBook(this.listParams).then(res => {
        this.staticBook = res.data.results;
        this.count = res.data.count;
      });
    },

    edit(item) {
      this.staticBookItem = item;
      this.$router.push({ name: "staticBookCreate", query: { id: item._id } });
    },

    remove(item) {
      this.staticBookItem = item;
      this.$store.commit("windowHandle", "delPopup");
    },
    deleteHandle() {
      this.$http.delStaticBook(this.staticBookItem._id).then(res => {
        this.getStaticBook();
      });
    },
    getPageNum(page) {
      this.listParams.page = page;
      this.getStaticBook();
    }
  },
  mounted() {
    this.getStaticBook();
  }
};
</script>

<style lang="scss" scoped>
.staticBook-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .list-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    .staticBook-handle {
      flex: 1;
      padding-right: 5px !important;
      flex-direction: column;
      .staticBook-item {
        margin: 10px;
        background: #f7f7f7;
        overflow: hidden;
        width: calc(25% - 22px);
        float: left;
        border: 1px solid #ddd;
        .staticBook-cover {
          height: 300px;
          background-color: #fff;
          .staticBook-img {
            width: 100%;
            height: 300px;
            display: block;
            margin: 0 auto;
          }
        }
        .staticBook-info {
          margin: 0 8px;
          overflow: hidden;
          > .staticBook-info-title {
            font-weight: bold;
            font-size: 14px;
            margin-top: 15px;
          }
          .staticBook-info-group {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > p {
            word-wrap: break-word;
            margin: 5px 0;
          }
          .grey {
            color: #fff;
            background-color: #828282;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
          .green {
            color: #fff;
            background-color: #3a983a;
            padding: 4px 8px;
            font-size: 14px;
            border-radius: 2px;
          }
        }
        .staticBook-btn {
          margin-top: 15px;
          margin-bottom: 10px;
          > .staticBook-el-icon {
            cursor: pointer;
            margin-left: 15px;
            font-size: 20px;
            padding: 2px;
            &:hover {
              background-color: #b5b5b5;
            }
            &.on-publish {
              color: #41b883;
            }
            &.off-publish {
              color: #d83a00;
            }
            &.disable-publish {
              color: #565656;
              cursor: not-allowed;
              &:hover {
                background-color: #dadada;
              }
            }
            &.staticBook-del {
              color: #d83a00;
            }
          }
          > span {
            color: #fff;
            padding: 4px 12px;
            border-radius: 3px;
            margin: 0 5px;
            cursor: pointer;
            display: inline-block;
            &.edit-btn {
              background-color: #337ab7;
              &:hover {
                background-color: #3783c4;
              }
            }
            &.del-btn {
              background-color: #d9534f;
              &:hover {
                background-color: #ef6f6c;
              }
            }
          }
        }
      }
    }
  }
}
</style>
